<template>
  <div class="identidad-ejes">
    <h2>THE DIMENSIONS OF GENDER AND SEX IDENTITY</h2>
    <div class="cols">
      <div class="col">
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          viewBox="0 0 705 843" style="enable-background:new 0 0 705 843;" xml:space="preserve">
            <title>Gender Expression</title>
            <g id="Layer_2">
              <g id="bg">
                <rect width="705" height="843"/>
              </g>
              <g id="base">
                <g>
                  <g>
                    <path class="st0" d="M566.5,437.3c17.8,3.7,30.7-4.8,41.8-17.3c12.9-14.6,20.9-32.4,31.7-48.4c10.6-15.7,15.4-33,19.2-51
                      c3.7-17.4,7.7-34.7,12-52c1.4-5.4-0.1-9.1-3.9-12.6c-6.1-5.4-5.5-9.8,1.6-13.9c24.4-14,31.5-50.7,14-72.5
                      c-2.9-3.6-5.4-3.3-6.8,1.1c-2.6,7.9-5,15.8-7.2,23.8c-2.1,7.5-5.3,14.2-12.5,18.2c-12.4,7-25.7-0.1-26.8-14.3
                      c-0.4-3.8-0.1-7.6,1-11.2c2.4-7.4,2.8-15.2,4-22.9c0.7-4.6-1.2-6.2-6-5.3c-8.7,1.4-16.4,6.5-21.2,13.9
                      c-11.4,16.9-10.7,45.6,2.2,57.9c3.6,3.5,2.7,6.5,2,10.1c-0.3,1.6-1.5,2.5-3,3.3c0,0-6.3,4.6-9.4,10.6
                      c-3.1,5.9-43.7,72.2-49.1,85s-1.3,32-1.3,32l14.5,62.8C563.2,434.6,564.9,437,566.5,437.3z M576.5,432.2
                      c-9.7-0.2-12.2-0.4-10.8-7.4c-3-6-6.9-27.9-6-32c-6-28-13.4-14.5-6.2-38c7.4-24.4,39.1-66.8,50.3-88.3c0.7-4.5,2-5.7,6-2.9
                      c14.5,9.9,30.6,12.7,47.7,10.4c4.9-0.7,6,0.6,4.8,5.4c-4.1,16.7-7.7,33.5-11.7,50.3c-1.8,7.7-2.3,15.8-6.5,22.8
                      c-5.5,9.5-11.2,18.9-16.7,28.4c-8.3,14-16.2,28.3-28,39.8C592.3,427.5,584.1,432.1,576.5,432.2L576.5,432.2z M680.3,178.3
                      c11.9,17.7,5.3,48.2-13.1,57.5c-8,4.1-10.8,9-10.2,17.1c0.1,0.9-0.2,1.9-0.1,2.8c0.1,3.2-1.7,4.8-4.7,5.4
                      c-11.3,2.4-21.8,0.3-31.7-5.5c-3.6-2.1-5-4.8-3.9-9c1-3.8,1.5-7.8,2.3-11.7c0.6-2.9,0.1-5.2-2.8-6.7c-4.7-2.5-6.9-7-8.4-11.7
                      c-3.2-10-3.2-20.7,0-30.7c2.4-7.6,6.5-14.1,13.7-18.1c1.5-0.8,3-2.2,4.7-1.3c1.9,1,1.1,3,1.1,4.6c0.2,5.8-2.6,10.4-5.5,15.2
                      c-6.8,11.2-5.9,23.7,2,33.4c8,9.6,21,13.3,32.9,9.5c10.1-3.3,17.7-13.9,18-26.5C675,194.4,677.9,186.9,680.3,178.3L680.3,178.3z
                      M624,204.4c2.9,8.2,8.1,14,16.6,16.5c8.8,2.6,16.1-0.8,24.1-5.9c-5.8,8.3-13.5,11.2-22.4,9.1
                      C631.8,221.7,625.4,214.8,624,204.4L624,204.4z"/>
                    <path class="st1" d="M548.5,339.9c-6.2-9.4-14.9-13.7-26.1-12.7c-1.5,0.1-3,0.1-4.5,0c-2.9-0.1-6.5,0.8-6.6-4
                      c-0.1-4-0.6-7.5,5-9.1c15-4.5,23.2-15.5,23.3-31.2c0.2-28,0.2-56,0-84c-0.2-20-13.2-32.7-33.4-33c-4.6-0.1-6.5-1.4-6.2-6.2
                      c0.3-5.1,0.2-10.2,0-15.3c-0.3-8.4-4.7-13.4-12.9-13.5c-22-0.2-43.9-0.2-65.9,0c-9.4,0.1-13.6,4.9-13.7,14.4
                      c0,4.7-0.3,9.5,0.1,14.2c0.4,5.2-1.8,6.7-6.6,6.4c-6.1-0.4-12.1-0.2-17.9,2.3c-12.8,5.6-19.3,15.9-19.5,29.5
                      c-0.4,28.6-0.4,57.2,0,85.8c0.2,15.9,9.1,27.1,24.8,31.3c6.5,1.7,4,6.3,4.2,10c0.2,4-3.2,3-5.4,2.8
                      c-12.8-0.6-24.2,1.7-31.4,13.8c-0.8,1.4-2.5,2-4,1.5c-17.9-3.2-30.6,5.5-41.3,18.3c-12.5,14.9-20,33-30.4,49.2
                      c-10.2,16-14.5,33.4-17.9,51.5c-3.2,17.5-6.8,34.9-10.6,52.3c-1.2,5.5,0.3,9.1,4.2,12.5c6.2,5.3,5.8,9.7-1.3,13.9
                      c-24,14.6-30.1,51.5-12.1,72.9c3,3.5,5.5,3.2,6.8-1.2c2.4-7.9,4.5-16,6.6-24c1.9-7.5,5-14.3,12-18.5
                      c12.2-7.3,25.7-0.5,27.1,13.6c0.5,3.8,0.2,7.6-0.7,11.3c-2.2,7.5-2.4,15.3-3.4,23c-0.6,4.6,1.4,6.2,6.1,5.2
                      c8.7-1.7,16.2-6.9,20.9-14.4c11-17.1,9.6-45.8-3.6-57.7c-3.7-3.4-2.9-6.5-2.3-10.1c0.3-1.6,1.5-2.5,2.9-3.3
                      c3.4-1.9,5.7-2.3,5.2,2.8c-0.2,1.7,0.1,3.4,0,5.1c-0.2,3.6,1.3,5.5,4.9,5.2c4.8-0.4,5.4,2.3,5.5,6.3
                      c1.7,85.9,0.5,171.8,0.8,257.8c0,8.4-0.1,8.4,8.2,8.4c33.9,0,67.8,0,101.7,0c8.6,0,8.7-0.2,8.7-9c0-38.4,0-76.9,0-115.3
                      c0-2.1-1-4.8,1.4-6.3c3.1-2.1,6.2,0.2,6.2,4.6c0,25.6,0,51.1,0,76.7c0,14.2,0.2,28.4-0.1,42.6c-0.1,4.8,1.4,6.8,6.4,6.8
                      c34.8-0.1,69.7-0.1,104.5,0c5.8,0,6.8-2.6,6.8-7.6c-0.1-43-0.1-86-0.1-128.9l0,0c0-42.8,0.1-85.6-0.1-128.3c0-5.2,0.7-8.5,7-7.9
                      c4.8,0.4,4.6-3.1,4.8-6.5c0.1-2-1.3-5,1.8-5.8L548.5,339.9z M452.9,543.9L452.9,543.9l-93.7,0.1c-9.5,0-18.9,0-28.4,0
                      c-2.8,0-4.9-0.6-4.9-4c0.1-6.2-0.6-12.5,0.5-18.7c10.1-55.5,20.3-110.9,30.5-166.3c2.6-14.5,10.2-20.8,24.9-20.8
                      c7,0,14,0.1,21-0.1c41.6-1.3,83.3-0.3,125-0.5c8,0,15.4,6.5,16.9,14.2c10.1,52.5,22.2,104.7,31.6,157.4c1.9,10.6,4.1,21.2,4,32
                      c0,4.2-1.3,6.2-5.9,6.2c-12.3,0-24.6,0.5-36.9,0.5C509.4,544,481.2,543.9,452.9,543.9z M451.8,309.2L451.8,309.2
                      c-18.9,0-37.9,0.2-56.8-0.1c-13.7-0.2-22.8-8.4-25-21.6c-1-6.1,0.1-12.1,0.1-18.1c-0.1-23.7-0.1-47.3,0-71
                      c0.1-16.6,9.8-26.4,26.5-26.5c36.3-0.1,72.7-0.1,109,0c17.3,0,27.7,10.2,27.8,27.4c0.1,27.4,0.1,54.9,0,82.3
                      c-0.1,17.5-10.2,27.4-27.6,27.5C487.8,309.3,469.8,309.2,451.8,309.2L451.8,309.2z M387.1,673.7L387.1,673.7
                      c-14.6,0-29.1-0.1-43.7,0.1c-4.7,0.1-6.3-1.6-6.3-6.2c0.1-25.3,0.1-50.7,0-76c0-4.8,1.8-6.2,6.4-6.2c28.8,0.1,57.5,0.1,86.3,0
                      c4.7,0,6.3,1.6,6.2,6.3c-0.1,25.3-0.1,50.7,0,76c0,4.8-1.8,6.2-6.4,6.1C415.5,673.5,401.3,673.7,387.1,673.7z M519.6,673.5
                      L519.6,673.5c-14.4,0.1-28.8,0-43.1,0.1c-4.3,0-6-1.3-6-5.8c0.1-25.5,0.1-51.1,0-76.6c0-4.5,1.7-5.9,6-5.9
                      c28.8,0.1,57.5,0.1,86.3,0c4.3,0,6.1,1.3,6,5.8c-0.2,25.5-0.2,51.1,0,76.6c0,4.5-1.6,5.9-6,5.8
                      C548.4,673.3,534,673.4,519.6,673.5L519.6,673.5z M390.1,762.4L390.1,762.4c-14.9,0-29.9,0-44.8,0c-7.9,0-8-0.1-8-7.8
                      c0-22.1,0-44.3,0-66.4c0-8.3,0-8.3,8.6-8.3h8.5c25.3,0,50.7,0,76.1,0c5.5,0,12.6,6,12.6,10.5c0,22.1-0.1,44.3,0,66.4
                      c0,4.2-1.7,5.6-5.8,5.6C421.5,762.3,405.8,762.4,390.1,762.4z M515.8,762.5L515.8,762.5c-15.5,0.1-31-0.1-46.5,0.2
                      c-4.6,0.1-5.9-1.2-5.9-5.7c0.2-21.4,0-42.7,0.1-64.1c0-6.7,6.6-13.3,13.2-13.3c28.6,0,57.1,0.1,85.7-0.1c5.1,0,6.4,1.8,6.4,6.7
                      c-0.2,23.1-0.2,46.1,0,69.2c0.1,5.4-1.5,7.3-7,7.2C546.4,762.3,531.1,762.5,515.8,762.5z M341.7,348.2c9.7-0.1,10.1,0.4,8.8,7.4
                      c-0.7,4.1-1.5,8.2-2.3,12.3c-4.5,24.2-7.5,48.7-14,72.4c-6.9,24.4-12,49.2-15.5,74.3c-0.6,4.5-1.8,5.8-6,3.1
                      c-14.7-9.6-30.9-11.9-47.9-9.1c-4.9,0.8-6-0.4-5-5.3c3.6-16.8,6.8-33.7,10.4-50.6c1.6-7.7,1.9-15.8,5.9-23
                      c5.3-9.6,10.7-19.2,16-28.8c7.9-14.2,15.4-28.7,27-40.5C326,353.2,334.1,348.4,341.7,348.2z M451.9,550.5
                      c36.5,0,73.1,0.1,109.6-0.1c5.9,0,7.8,1.8,7.2,7.4c-0.4,4.1-0.1,8.3-0.1,12.5c0,8,0,8-8.2,8H350.9c-3,0-6.1-0.2-9.1,0
                      c-4.3,0.3-5.7-1.6-5.5-5.7c0.2-4.5,0-9.1,0-13.6c0-8.5,0-8.5,8.2-8.5L451.9,550.5z M389.8,768.6L389.8,768.6
                      c15.7-0.1,31.4,0.1,47.1-0.1c4.4,0,6.1,1.4,6,5.9c-0.2,11.9-0.2,23.8,0,35.8c0.1,4.5-1.9,6-6.1,6c-31.2-0.1-62.5-0.1-93.7,0
                      c-4.4,0-6.1-1.7-6-6c0.2-11.7,0.3-23.5,0-35.2c-0.1-5.2,2-6.4,6.7-6.3C359.1,768.7,374.5,768.6,389.8,768.6L389.8,768.6z
                      M516.3,769.3c0-0.2,0-0.4,0-0.6c15.5,0,31,0.1,46.5-0.1c4.5-0.1,6,1.6,5.9,6c-0.2,11.9-0.2,23.8,0,35.8
                      c0.1,4.2-1.5,5.7-5.7,5.7c-31.2-0.1-62.5-0.1-93.7,0c-4.4,0-6.1-1.5-6-6c0.2-11.5,0.2-23.1,0-34.6c-0.1-4.8,1.8-6.3,6.4-6.2
                      C485.3,769.4,500.8,769.3,516.3,769.3L516.3,769.3z M244.6,604.7c-12.4-17.4-6.5-48,11.6-57.9c7.9-4.3,10.5-9.3,9.8-17.4
                      c-0.1-0.9,0.1-1.9,0.1-2.8c-0.1-3.2,1.6-4.8,4.5-5.5c11.2-2.7,21.8-0.8,31.8,4.6c3.6,2,5.1,4.7,4.1,8.9c-0.9,3.8-1.3,7.8-2,11.7
                      c-0.5,2.9,0.1,5.2,2.9,6.6c4.7,2.4,7.1,6.8,8.7,11.5c3.4,9.9,3.7,20.7,0.8,30.7c-2.2,7.7-6.1,14.2-13.2,18.4
                      c-1.4,0.8-2.9,2.2-4.7,1.4c-1.9-0.9-1.1-3-1.2-4.6c-0.3-5.8,2.3-10.5,5.1-15.3c6.4-11.3,5.2-23.9-2.9-33.3
                      c-8.2-9.4-21.3-12.8-33.1-8.6c-10,3.6-17.3,14.3-17.3,27C249.4,588.4,246.7,596,244.6,604.7z M454.2,165.8
                      c-11.7,0-23.5-0.1-35.2,0c-3.8,0-5.6-1.4-5.5-5.3c0.1-5.5,0.1-11,0.1-16.5c0-4.7,2.6-7.1,7-7.1c22-0.1,43.9-0.1,65.9,0
                      c4.8,0,7.2,2.8,7.2,7.6c0,5.1-0.2,10.2,0.1,15.3c0.2,4.5-1.7,6-6,5.9C476.5,165.7,465.4,165.8,454.2,165.8z M442.1,633.5
                      c0-10.8,0-21.6,0-32.4c0-16,0-15.9,15.9-15.8c4.5,0,6.4,1.3,6.4,6.2c-0.1,27.5-0.3,54.9,0.2,82.3c0.1,6.2-6.3,12.1-11.9,11.8
                      c-5.2-0.3-10.6-6-10.6-11.8C442.1,660.4,442.1,646.9,442.1,633.5z M452.4,327.2c-15.9,0-31.8,0-47.7,0c-3.7,0-6-0.6-6.2-5.2
                      c-0.3-6.8,4.5-5.5,8-5.5c30.9-0.1,61.7,0,92.6-0.1c3.7,0,6,0.5,6,5.1s-2.1,5.7-6.2,5.6C483.4,327.1,467.9,327.2,452.4,327.2
                      L452.4,327.2z M300.2,577.2c-3.1-8.1-8.5-13.7-17.1-16.1c-8.8-2.4-16.1,1.2-24,6.5c5.6-8.5,13.2-11.5,22.2-9.7
                      C291.9,560.1,298.5,566.7,300.2,577.2L300.2,577.2z"/>
                    <path class="st1" d="M566.5,437.3c18.2,0.5,29.4-10.1,38.1-24.4c10.1-16.6,14.8-35.6,22.6-53.2c7.7-17.3,9.3-35.2,9.9-53.6
                      c0.6-17.8,1.4-35.5,2.6-53.3c0.4-5.6-1.7-8.9-6.1-11.7c-6.9-4.3-7.2-8.7-0.9-14c21.5-18.1,22-55.4,0.9-73.9
                      c-3.5-3-5.9-2.3-6.5,2.3c-1.2,8.2-2.1,16.5-2.9,24.7c-0.8,7.8-2.8,14.9-9.1,20.1c-11,9-25.3,4.4-28.9-9.4
                      c-1.1-3.6-1.4-7.5-1-11.2c1.1-7.8,0-15.5-0.1-23.2c-0.1-4.6-2.3-5.9-6.8-4.2c-8.3,3-15,9.3-18.4,17.5
                      c-8.3,18.6-2.5,46.7,12.3,56.5c4.2,2.8,3.8,5.9,3.8,9.6c0,1.6-1.1,2.7-2.3,3.7c0,0-5.3,5.7-7.4,12.1c-2.1,6.4-16.4,54-19.4,67.6
                      s-0.5,36.5-0.5,36.5l16.4,79.3C562.8,435.2,564.9,437.3,566.5,437.3z M575.5,430.5c-9.6,1.5-10,1.1-9.8-6
                      c0.1-4.2-5-19.6-4.8-23.8c-4.5-27.1-10.7-42.8-7.9-67.1c3-25.3,12.8-47.8,20.1-71c-0.1-4.5,0.9-6,5.4-3.9
                      c16,7.2,32.3,7,48.8,1.8c4.7-1.5,6-0.5,5.7,4.5c-1,17.2-1.6,34.4-2.6,51.6c-0.5,7.9,0.5,15.9-2.3,23.6
                      c-3.8,10.3-7.6,20.6-11.5,30.9c-5.7,15.3-10.9,30.7-20.5,44.1C590.2,423.1,582.9,429.1,575.5,430.5L575.5,430.5z M632.6,162.2
                      c14.9,15.3,13.7,46.5-2.7,59c-7.1,5.4-9,10.8-7,18.6c0.2,0.9,0.2,1.9,0.4,2.8c0.6,3.1-0.8,5-3.6,6.2
                      c-10.7,4.4-21.4,4.1-32.1,0.2c-3.9-1.4-5.7-3.9-5.4-8.1c0.3-4,0.1-7.9,0.2-11.9c0.1-3-0.8-5.1-3.9-6.1c-5-1.7-8-5.6-10.3-10
                      c-4.9-9.3-6.8-19.9-5.4-30.3c1-7.9,3.9-15,10.3-20.2c1.3-1,2.5-2.7,4.4-2.1c2,0.6,1.6,2.8,1.9,4.4c1.2,5.7-0.7,10.7-2.7,15.9
                      c-4.7,12.2-1.6,24.4,7.8,32.5c9.6,8,23,9.4,34,3.5c9.4-5,15-16.8,13-29.3C630.3,179.1,631.8,171.1,632.6,162.2L632.6,162.2z
                      M581.8,197.9c4.3,7.5,10.4,12.3,19.3,13.3c9.1,1,15.7-3.6,22.7-10.1c-4.2,9.2-11.3,13.4-20.5,12.9
                      C592.6,213.5,585.1,207.9,581.8,197.9z"/>
                  </g>
                  <g>
                    <path class="st2" d="M491.7,275.7c0,9.9-18.8,18-42,18s-42-8.1-42-18"/>
                    <ellipse class="st1" cx="408.2" cy="237.7" rx="7" ry="13.5"/>
                    <ellipse class="st1" cx="492.7" cy="238.2" rx="7" ry="13.5"/>
                  </g>
                </g>
              </g>
              <g id="sex" @click="active = 'sex'">
                <g id="trigger-sex">
                  <circle class="st3" cx="452.4" cy="556.7" r="23"/>
                  <line class="st3" x1="452.4" y1="604.7" x2="452.4" y2="579.2"/>
                  <line class="st3" x1="440.4" y1="593.2" x2="464.4" y2="593.2"/>
                  <g>
                    <line class="st3" x1="420.4" y1="528" x2="434.4" y2="542"/>
                    <polygon class="st4" points="421.5,541 421.5,529 433.5,529 428.4,524 416.4,524 416.4,535.9 				"/>
                  </g>
                  <g>
                    <line class="st3" x1="484.3" y1="528.6" x2="470.3" y2="542.6"/>
                    <polygon class="st4" points="471.2,529.6 483.2,529.6 483.2,541.6 488.3,536.5 488.3,524.5 476.3,524.5 				"/>
                  </g>
                  <line class="st3" x1="436.2" y1="532.2" x2="424.2" y2="543.2"/>
                </g>
                <g id="text-sex">
                  <text transform="matrix(1 0 0 1 137.5471 521.9881)" class="st5 st6 st7">SE</text>
                  <text transform="matrix(1 0 0 1 177.127 521.9881)" class="st5 st6 st7 st8">X</text>
                  <path class="st9" d="M441.7,515.5c0,0-20.7-73.8-108.6-73.8s-107.4,51.8-107.4,51.8"/>
                </g>
              </g>
              <g id="orientation" @click="active = 'orientation'">
                <path id="trigger-orientation" class="st10" d="M527.9,355.2h-11.1c-5.3,0-9.5,4.3-9.5,9.5c0-5.3-4.3-9.5-9.5-9.5h-11.1
                  c-5.3,0-9.5,4.3-9.5,9.5v4.8c0,15.9,30.2,32.2,30.2,32.2s30.2-17.9,30.2-32.2v-4.8C537.4,359.5,533.1,355.2,527.9,355.2z"/>
                <g id="text-orientation">
                  <text transform="matrix(1 0 0 1 114.607 366.9781)" class="st5 st6 st7">SEXUAL</text>
                  <text transform="matrix(1 0 0 1 20.6671 400.9781)" class="st5 st12 st7">ORIENTATION</text>
                  <path class="st9" d="M476.7,368c0,0-33.8-81.3-119.7-81.3s-118.3,57.1-118.3,57.1"/>
                </g>
              </g>
              <g id="expression" @click="active = 'expression'">

                <linearGradient id="trigger-expression_3" gradientUnits="userSpaceOnUse" x1="226.7225" y1="383.3631" x2="697.6376" y2="383.3631" gradientTransform="matrix(1 0 0 -1 0 859.6161)">
                  <stop  offset="0" style="stop-color:#23AFEC"/>
                  <stop  offset="1" style="stop-color:#E9008B"/>
                </linearGradient>
                <path id="trigger-expression" class="st14" d="M454,130.3c11,0,21.9,0.1,32.9,0.2c8.2,0.1,12.7,5.1,12.9,13.5
                  c0.2,5.1,0.3,10.2,0,15.3c-0.3,4.8,1.6,6.1,6.2,6.2c20.2,0.3,33.2,13,33.4,33c0.2,28,0.2,56,0,84c-0.1,15.6-8.3,26.7-23.3,31.2
                  c-5.5,1.6-5,5.1-5,9.1c0.1,3.8,2.3,4,4.6,4h1.1h0.9c0.8,0,1.7,0.1,2.5,0.1c0.7,0,1.3,0,2-0.1c1-0.1,2.1-0.1,3.1-0.1
                  c7.7-0.2,15,3.1,20,8.8c-0.1-5.6,0.4-11.1,1.5-16.6c3-13.6,17.3-61.2,19.4-67.6c2.1-6.4,7.4-12.1,7.4-12.1c1.2-1,2.3-2.1,2.3-3.7
                  c0.1-3.7,0.4-6.8-3.8-9.6c-14.8-9.8-20.6-37.9-12.3-56.5c3.4-8.1,10.1-14.5,18.4-17.4c1-0.4,2.2-0.7,3.3-0.7
                  c2.3,0,3.5,1.6,3.5,4.9c0.2,7.7,1.2,15.5,0.1,23.2c-0.4,3.8-0.1,7.6,1,11.2c1.9,7.5,7.1,12.3,13.1,13.6c-0.6-11.2,2.1-23.1,8-31.8
                  c4.4-6.8,11.3-11.6,19.2-13.5c0.2-1.3,0.3-2.5,0.5-3.8c0.4-2.7,1.4-4.1,2.9-4.1c1.4,0.2,2.7,0.8,3.6,1.8
                  c17.1,14.9,20,42.2,9.1,61.7c1.2,0.3,2.5,0.4,3.8,0.4c3.4,0,6.8-1,9.8-2.7c7.1-4,10.4-10.7,12.5-18.2c2.3-8,4.6-15.9,7.2-23.8
                  c0.8-2.4,1.9-3.6,3.2-3.6c1.1,0,2.3,0.8,3.7,2.5c17.5,21.9,10.4,58.6-14,72.5c-7.1,4.1-7.7,8.4-1.6,13.9c3.8,3.5,5.3,7.1,3.9,12.6
                  c-4.3,17.2-8.3,34.6-12,52c-3.8,18-8.6,35.3-19.2,51c-10.8,15.9-18.7,33.8-31.7,48.4c-9.3,10.5-19.8,18.1-33.5,18.1
                  c-2.2,0-4.4-0.2-6.6-0.6l20.2,100c-3.1,0.8-1.8,3.8-1.8,5.8c-0.1,3.2,0,6.5-4,6.5c-0.2,0-0.5,0-0.8,0c-0.5,0-0.9-0.1-1.3-0.1
                  c-5,0-5.7,3.2-5.7,8c0.1,42.8,0.1,85.6,0.1,128.3l0,0c0,43-0.1,86,0.1,128.9c0,5-1,7.6-6.7,7.6h-0.1c-17-0.1-34.1-0.1-51.1-0.1
                  c-17.8,0-35.6,0-53.4,0.1h-0.1c-5,0-6.4-1.9-6.3-6.8c0.2-14.2,0.1-28.4,0.1-42.6c0-25.6,0-51.1,0-76.7c0-3.3-1.7-5.4-3.9-5.4
                  c-0.8,0-1.6,0.3-2.3,0.8c-2.3,1.5-1.4,4.2-1.4,6.3c-0.1,38.4-0.1,76.9,0,115.3c0,8.9-0.1,9-8.7,9H339.2c-8.3,0-8.2,0-8.2-8.4
                  c-0.3-85.9,0.9-171.8-0.8-257.8c-0.1-3.8-0.6-6.3-4.6-6.3c-0.3,0-0.6,0-0.9,0c-0.2,0-0.5,0-0.7,0c-3.1,0-4.4-1.9-4.2-5.2
                  c0.1-1.7-0.1-3.4,0-5.1c0.3-3-0.4-4.2-1.7-4.2c-1.2,0.2-2.4,0.6-3.5,1.3c-1.4,0.8-2.6,1.8-2.9,3.3c-0.6,3.6-1.5,6.7,2.3,10.1
                  c13.2,11.9,14.6,40.6,3.6,57.7c-4.6,7.5-12.2,12.8-20.9,14.4c-0.8,0.2-1.6,0.3-2.4,0.3c-3,0-4.2-1.7-3.7-5.5
                  c1-7.7,1.2-15.5,3.4-23c1-3.7,1.2-7.5,0.7-11.3c-1-10.2-8.3-16.6-16.9-16.6c-3.6,0.1-7.1,1.1-10.2,3c-7,4.2-10.1,10.9-12,18.5
                  c-2.1,8-4.2,16.1-6.6,24c-0.7,2.4-1.8,3.6-3.1,3.6c-1.1,0-2.3-0.8-3.7-2.4c-18.1-21.4-11.9-58.3,12.1-72.9c7-4.3,7.5-8.6,1.3-13.9
                  c-3.9-3.4-5.5-7-4.2-12.5c3.9-17.4,7.4-34.8,10.6-52.3c3.4-18.1,7.7-35.5,17.9-51.5c10.4-16.2,17.9-34.3,30.4-49.2
                  c9.2-11,19.9-19,34-19c2.4,0,4.9,0.2,7.3,0.7c0.3,0.1,0.7,0.1,1,0.1c1.2,0.1,2.3-0.6,2.9-1.6c6.5-10.9,16.5-13.9,27.8-13.9
                  c1.2,0,2.4,0,3.7,0.1c0.8,0,1.8,0.2,2.7,0.2c1.5,0,2.9-0.5,2.7-3c-0.2-3.6,2.4-8.2-4.2-10c-15.6-4.1-24.6-15.3-24.8-31.3
                  c-0.3-28.6-0.4-57.2,0-85.7c0.2-13.6,6.8-23.8,19.5-29.5c4.2-1.7,8.7-2.6,13.3-2.4c1.5,0,3.1,0.1,4.6,0.2c0.4,0,0.8,0,1.1,0
                  c4,0,5.8-1.6,5.5-6.4s-0.1-9.5-0.1-14.2c0.1-9.5,4.2-14.3,13.7-14.4C432,130.3,443,130.3,454,130.3 M454,125.3
                  c-11.1,0-22.3,0.1-33,0.2c-11.9,0.1-18.5,7-18.6,19.4c0,1.2,0,2.4-0.1,3.6c-0.1,3.6-0.1,7.3,0.1,11.1c0,0.3,0,0.7,0,1h-0.5h-0.8
                  c-1.8-0.1-3.4-0.2-4.9-0.2c-5.2-0.1-10.5,0.8-15.3,2.9c-14.5,6.4-22.3,18.1-22.5,34c-0.4,25.7-0.4,53,0,85.9
                  c0.2,18.2,10.6,31.3,28.5,36c0.3,0.1,0.5,0.2,0.8,0.3c0,0.5-0.1,1.1-0.1,1.7c0,0.3-0.1,0.7-0.1,1.1h-0.2c-1.4-0.1-2.7-0.1-3.9-0.1
                  c-9.4,0-22.8,1.6-31.5,15.4c-2.5-0.4-5-0.6-7.5-0.6c-18.3,0-30.4,11.9-37.9,20.8c-8.3,9.9-14.4,21-20.4,31.8
                  c-3.3,6-6.7,12.2-10.4,18c-10.2,15.9-14.8,32.8-18.6,53.2c-3.5,18.8-7,35.8-10.6,52.1c-1.6,7.1,0.3,12.6,5.9,17.3
                  c2.2,1.9,2.5,2.9,2.6,3.1s-0.6,1.2-3.2,2.8c-12.7,7.8-21.6,21.4-24.2,37.5s1.4,31.5,10.9,42.8c2.3,2.8,4.9,4.2,7.5,4.2
                  c1.7,0,6-0.7,7.9-7.2c2.1-7,4.2-14.5,6.7-24.2c2-8,5-12.6,9.7-15.4c2.3-1.4,4.9-2.2,7.6-2.3c6.4,0,11.2,4.9,12,12.1
                  c0.4,3.1,0.2,6.3-0.5,9.3c-1.5,5.6-2.4,11.3-2.8,17.1c-0.2,2.3-0.5,4.5-0.7,6.7c-0.5,3.5,0.2,6.3,1.9,8.3c1.7,1.9,4.2,2.9,6.7,2.8
                  c1.1,0,2.3-0.1,3.4-0.4c10-1.9,18.7-8,24.1-16.6c1.6-2.5,2.9-5.1,4-7.9c0.4,42.2,0.3,84.4,0.2,125.7c-0.1,28.1-0.1,57.1,0,85.6
                  v0.3c0,4.9,0,8.2,2.5,10.7s5.8,2.5,10.7,2.5h101.7c5,0,8.6,0,11.2-2.7c0.6-0.6,1.1-1.3,1.5-2.1c0.4,0.7,0.9,1.4,1.4,1.9
                  c2.9,3,7.1,3,8.5,3h0.1c18.9-0.1,36.4-0.1,53.4-0.1c17.6,0,34.8,0,51.1,0.1h0.1c3.8,0,6.7-1,8.7-3c2.7-2.7,3-6.4,3-9.7
                  c-0.1-33.1-0.1-66.7-0.1-99.2c0-9.9,0-19.8,0-29.7v-5l0,0c0-8.3,0-16.5,0-24.8c0-32.3,0-65.7-0.1-98.6c0-1,0-2,0.2-2.9h0.5
                  c0.3,0,0.5,0,0.9,0s0.8,0.1,1.2,0.1c3.4,0.2,6.5-1.7,8-4.7c0.7-1.9,1.1-4,1-6v-0.5c0-0.5,0-1.1-0.1-1.6l2.8-0.7l-1-4.7l-18.8-93.5
                  h0.4c17.7,0,29.8-11.3,37.3-19.8c8.5-9.6,15-20.6,21.2-31.2c3.5-5.9,7-12,10.9-17.7c10.6-15.6,15.7-32.4,20-52.7
                  c4-18.7,7.9-35.6,12-51.8c1.8-7,0-12.6-5.4-17.5c-2.2-2-2.5-3-2.5-3.2s0.6-1.1,3.3-2.7c12.9-7.4,22.1-20.9,25.2-36.9
                  s-0.5-31.6-9.8-43.1c-2.3-2.9-4.8-4.4-7.5-4.4c-2.1,0-5.9,0.9-7.9,7c-2.3,7-4.5,14.4-7.3,24c-2.2,7.9-5.3,12.5-10.1,15.2
                  c-1,0.6-2.1,1.1-3.2,1.4c3.3-8.9,4.3-18.6,3-28C652,168.5,646,157,637,149.1c-2.4-2.1-4.6-3.1-6.9-3.1c-1.6,0-6.8,0.6-7.9,8.4
                  l-0.1,0.6c-7.7,2.6-14.4,7.7-18.8,14.6c-4.9,7.2-8,16.5-8.8,26.3c-1.6-1.9-2.8-4.1-3.4-6.5c-0.9-3-1.2-6.2-0.9-9.3
                  c0.6-5.7,0.7-11.5,0.2-17.3c-0.1-2.3-0.2-4.5-0.3-6.7c-0.1-7.2-4.5-9.8-8.5-9.8c-1.7,0-3.4,0.4-5,1c-9.6,3.4-17.3,10.7-21.3,20.1
                  c-4.4,9.9-5.4,22.5-2.8,34.6c2.7,12.5,8.8,22.7,17,28.1c1.6,1,1.6,1.4,1.5,4.6v0.2c-0.1,0.1-0.2,0.2-0.5,0.4l-0.3,0.2l-0.2,0.3
                  c-0.2,0.3-6.1,6.6-8.5,14c-1.9,5.8-16.4,53.9-19.5,68.1c-0.5,2.5-0.9,5.1-1.1,7.6c-4.7-2.6-10.1-3.9-15.4-3.8
                  c-1.2,0-2.3,0-3.5,0.2c-0.5,0-1,0.1-1.6,0.1c-0.8,0-1.5,0-2.3-0.1h-1.1h-0.7c-0.1-0.9,0-1.8,0.1-2.7c0.4-0.3,0.8-0.5,1.3-0.6
                  c8.5-2.5,15.2-7,19.8-13.2s7-13.8,7-22.7c0.2-32,0.2-58.8,0-84.1c-0.2-22.8-15.2-37.7-38.3-38c-0.4,0-0.9,0-1.3-0.1
                  c0-0.2,0-0.5,0-0.8c0.3-5.2,0.2-10.2,0-15.8c-0.3-11.2-7.2-18.2-17.9-18.4C475.9,125.3,464.8,125.2,454,125.3L454,125.3z
                  M323.9,554.7c0.4,0,0.7,0,1.1,0l0,0c0,0.3,0.1,0.8,0.1,1.4c0,0.3,0,0.7,0,1.1C324.7,556.4,324.3,555.6,323.9,554.7L323.9,554.7z"
                  />
                <g id="text-expression">
                  <text transform="matrix(1 0 0 1 338.857 41.9781)" class="st5 st6 st7">GENDER</text>
                  <text transform="matrix(1 0 0 1 334.5471 75.9781)" class="st5 st12 st7">EXPRESSION</text>
                  <path class="st9" d="M615.7,146.6c0,0,16.4-43.4-14.1-73.8s-64.5-22.5-64.5-22.5"/>
                </g>
              </g>
              <g id="identity" @click="active = 'identity'">
                <g id="trigger-identity">
                  <g id="trigger-identity_1_">
                    <path class="st15" d="M491.2,175.6c-0.6-7.3-6.8-13-14.2-13l0,0c-1.4-6.6-7.2-11.3-13.9-11.4h-18.4c-6.7,0.1-12.5,4.8-13.9,11.4
                      l0,0c-7.4,0-13.6,5.7-14.2,13.1c-7.6,1.9-12.3,9.6-10.4,17.2c1.4,5.5,5.9,9.7,11.5,10.6c2.1,5.6,7.4,9.3,13.4,9.4h21.9
                      c0.7,0.4,1.6,0.4,2.4,0h21.9c6,0,11.3-3.8,13.4-9.4c7.8-1.2,13.1-8.4,11.9-16.2C501.8,181.4,497.2,176.6,491.2,175.6
                      L491.2,175.6z"/>
                  </g>
                  <path class="st16" d="M491.2,175.6c-0.6-7.3-6.8-13-14.2-13l0,0c-1.4-6.6-7.2-11.3-13.9-11.4h-18.4c-6.7,0.1-12.5,4.8-13.9,11.4
                    l0,0c-7.4,0-13.6,5.7-14.2,13.1c-7.6,1.9-12.3,9.6-10.4,17.2c1.4,5.5,5.9,9.7,11.5,10.6c2.1,5.6,7.4,9.3,13.4,9.4h21.9
                    c0.7,0.4,1.6,0.4,2.4,0h21.9c6,0,11.3-3.8,13.4-9.4c7.8-1.2,13.1-8.4,11.9-16.2C501.8,181.4,497.2,176.6,491.2,175.6L491.2,175.6
                    z M488.7,198.7l-2,0.1l-0.4,1.9c-0.9,4.2-4.7,7.2-9,7.2h-10.7c0.6-2.2,2.8-4.2,10.7-4.2h2.8l-0.3-2.8c0,0-0.4-4,1.8-6.6
                    c1.4-1.5,3.5-2.3,6.5-2.3v-5h-14.1c1.3-1.9,2-4.1,1.9-6.4c0-1.4-1.1-2.5-2.5-2.5s-2.5,1.1-2.5,2.5c0,6.1-7.1,6.4-7.9,6.4v5h14
                    c-1.3,2-2.1,4.4-2.3,6.8c-5.7,0.3-12,2-13.2,9.1h-4.9v-2.6c0.2-0.4,0.3-0.8,0.3-1.2c-0.1-2.7,2.1-5,4.8-5.1
                    c1.4,0,2.5-1.1,2.5-2.5s-1.1-2.5-2.5-2.5c-1.8,0-3.6,0.5-5.1,1.5v-8.6c0.2-0.4,0.3-0.8,0.3-1.2c-0.1-2.7,2.1-5,4.8-5.1
                    c1.4,0,2.5-1.1,2.5-2.5s-1.1-2.5-2.5-2.5c-1.8,0-3.6,0.5-5.1,1.5v-13.6c0-1.4-1.1-2.5-2.5-2.5s-2.5,1.1-2.5,2.5V177
                    c-1.5-0.9-3.3-1.4-5.1-1.4c-1.4,0-2.5,1.1-2.5,2.5s1.1,2.5,2.5,2.5c2.8,0,5.1,2.3,5.1,5.1v9.7c-1.5-0.9-3.3-1.4-5.1-1.4
                    c-1.4,0-2.5,1.1-2.5,2.5s1.1,2.5,2.5,2.5c2.8,0,5.1,2.3,5.1,5.1v3.8h-4.9c-1.2-7.1-7.8-8.8-13.7-9.1c-0.2-2.4-1-4.8-2.4-6.8h14.6
                    v-5c-0.3,0-8.3-0.1-8.3-6.4c0-1.4-1.1-2.5-2.5-2.5s-2.5,1.1-2.5,2.5c-0.1,2.3,0.7,4.5,2,6.4h-14.7v5c3.1,0,5.4,0.8,6.9,2.4
                    c2.3,2.6,1.8,6.5,1.8,6.5l-0.4,2.8h2.8c8.2,0,10.5,2,11.2,4.2h-10.7c-4.3,0-8.1-3-9-7.2l-0.4-1.9l-2-0.1c-5.1-0.1-9.1-4.3-9-9.4
                    c0.1-4.8,3.8-8.7,8.6-9l2.5-0.2V180h4.2c1.4,0,2.5-1.1,2.5-2.5s-1.1-2.5-2.5-2.5h-4.3c0.9-4.3,4.6-7.3,9-7.4l0,0v6.1
                    c0,1.4,1.1,2.5,2.5,2.5s2.5-1.1,2.5-2.5v-8.9c0-0.3-0.1-0.6-0.2-0.9c0.8-4.4,4.6-7.7,9.1-7.7H463c4.7,0,8.6,3.5,9.1,8.2
                    c0,0.1,0,0.3,0,0.4v8.9c0,1.4,1.1,2.5,2.5,2.5s2.5-1.1,2.5-2.5v-6c4.3,0.1,8,3.1,8.9,7.3h-4.3c-1.4,0-2.5,1.1-2.5,2.5
                    s1.1,2.5,2.5,2.5h4.3v0.3l2.6,0.1c5.1,0,9.2,4.1,9.2,9.2C497.9,194.6,493.8,198.8,488.7,198.7L488.7,198.7z"/>
                </g>
                <g id="text-identity">
                  <text transform="matrix(1 0 0 1 117.407 195.9881)" class="st5 st6 st7">GENDER</text>
                  <text transform="matrix(1 0 0 1 103.5471 229.9881)" class="st5 st12 st7">IDENTITY</text>
                  <path class="st9" d="M421.7,174.7c0,0-15.5-55-81-55s-80,38.6-80,38.6"/>
                </g>
              </g>
            </g>
            <path id="trigger-expression_1_" class="st15" d="M454,125.3c-11.1,0-22.3,0.1-33,0.2c-11.9,0.1-18.5,7-18.6,19.4
              c0,1.2,0,2.4-0.1,3.6c-0.1,3.6-0.1,7.3,0.1,11.1c0,0.3,0,0.7,0,1h-0.5h-0.8c-1.8-0.1-3.4-0.2-4.9-0.2c-5.2-0.1-10.5,0.8-15.3,2.9
              c-14.5,6.4-22.3,18.1-22.5,34c-0.4,25.7-0.4,53,0,85.9c0.2,18.2,10.6,31.3,28.5,36c0.3,0.1,0.5,0.2,0.8,0.3c0,0.5-0.1,1.1-0.1,1.7
              c0,0.3-0.1,0.7-0.1,1.1h-0.2c-1.4-0.1-2.7-0.1-3.9-0.1c-9.4,0-22.8,1.6-31.5,15.4c-2.5-0.4-5-0.6-7.5-0.6
              c-18.3,0-30.4,11.9-37.9,20.8c-8.3,9.9-14.4,21-20.4,31.8c-3.3,6-6.7,12.2-10.4,18c-10.2,15.9-14.8,32.8-18.6,53.2
              c-3.5,18.8-7,35.8-10.6,52.1c-1.6,7.1,0.3,12.6,5.9,17.3c2.2,1.9,2.5,2.9,2.6,3.1s-0.6,1.2-3.2,2.8c-12.7,7.8-21.6,21.4-24.2,37.5
              s1.4,31.5,10.9,42.8c2.3,2.8,4.9,4.2,7.5,4.2c1.7,0,6-0.7,7.9-7.2c2.1-7,4.2-14.5,6.7-24.2c2-8,5-12.6,9.7-15.4
              c2.3-1.4,4.9-2.2,7.6-2.3c6.4,0,11.2,4.9,12,12.1c0.4,3.1,0.2,6.3-0.5,9.3c-1.5,5.6-2.4,11.3-2.8,17.1c-0.2,2.3-0.5,4.5-0.7,6.7
              c-0.5,3.5,0.2,6.3,1.9,8.3c1.7,1.9,4.2,2.9,6.7,2.8c1.1,0,2.3-0.1,3.4-0.4c10-1.9,18.7-8,24.1-16.6c1.6-2.5,2.9-5.1,4-7.9
              c0.4,42.2,0.3,84.4,0.2,125.7c-0.1,28.1-0.1,57.1,0,85.6v0.3c0,4.9,0,8.2,2.5,10.7s5.8,2.5,10.7,2.5h101.7c5,0,8.6,0,11.2-2.7
              c0.6-0.6,1.1-1.3,1.5-2.1c0.4,0.7,0.9,1.4,1.4,1.9c2.9,3,7.1,3,8.5,3h0.1c18.9-0.1,36.4-0.1,53.4-0.1c17.6,0,34.8,0,51.1,0.1h0.1
              c3.8,0,6.7-1,8.7-3c2.7-2.7,3-6.4,3-9.7c-0.1-33.1-0.1-66.7-0.1-99.2c0-9.9,0-19.8,0-29.7v-5l0,0c0-8.3,0-16.5,0-24.8
              c0-32.3,0-65.7-0.1-98.6c0-1,0-2,0.2-2.9h0.5c0.3,0,0.5,0,0.9,0s0.8,0.1,1.2,0.1c3.4,0.2,6.5-1.7,8-4.7c0.7-1.9,1.1-4,1-6v-0.5
              c0-0.5,0-1.1-0.1-1.6l2.8-0.7l-1-4.7l-18.8-93.5h0.4c17.7,0,29.8-11.3,37.3-19.8c8.5-9.6,15-20.6,21.2-31.2c3.5-5.9,7-12,10.9-17.7
              c10.6-15.6,15.7-32.4,20-52.7c4-18.7,7.9-35.6,12-51.8c1.8-7,0-12.6-5.4-17.5c-2.2-2-2.5-3-2.5-3.2s0.6-1.1,3.3-2.7
              c12.9-7.4,22.1-20.9,25.2-36.9s-0.5-31.6-9.8-43.1c-2.3-2.9-4.8-4.4-7.5-4.4c-2.1,0-5.9,0.9-7.9,7c-2.3,7-4.5,14.4-7.3,24
              c-2.2,7.9-5.3,12.5-10.1,15.2c-1,0.6-2.1,1.1-3.2,1.4c3.3-8.9,4.3-18.6,3-28C652,168.5,646,157,637,149.1c-2.4-2.1-4.6-3.1-6.9-3.1
              c-1.6,0-6.8,0.6-7.9,8.4l-0.1,0.6c-7.7,2.6-14.4,7.7-18.8,14.6c-4.9,7.2-8,16.5-8.8,26.3c-1.6-1.9-2.8-4.1-3.4-6.5
              c-0.9-3-1.2-6.2-0.9-9.3c0.6-5.7,0.7-11.5,0.2-17.3c-0.1-2.3-0.2-4.5-0.3-6.7c-0.1-7.2-4.5-9.8-8.5-9.8c-1.7,0-3.4,0.4-5,1
              c-9.6,3.4-17.3,10.7-21.3,20.1c-4.4,9.9-5.4,22.5-2.8,34.6c2.7,12.5,8.8,22.7,17,28.1c1.6,1,1.6,1.4,1.5,4.6v0.2
              c-0.1,0.1-0.2,0.2-0.5,0.4l-0.3,0.2l-0.2,0.3c-0.2,0.3-6.1,6.6-8.5,14c-1.9,5.8-16.4,53.9-19.5,68.1c-0.5,2.5-0.9,5.1-1.1,7.6
              c-4.7-2.6-10.1-3.9-15.4-3.8c-1.2,0-2.3,0-3.5,0.2c-0.5,0-1,0.1-1.6,0.1c-0.8,0-1.5,0-2.3-0.1h-1.1h-0.7c-0.1-0.9,0-1.8,0.1-2.7
              c0.4-0.3,0.8-0.5,1.3-0.6c8.5-2.5,15.2-7,19.8-13.2s7-13.8,7-22.7c0.2-32,0.2-58.8,0-84.1c-0.2-22.8-15.2-37.7-38.3-38
              c-0.4,0-0.9,0-1.3-0.1c0-0.2,0-0.5,0-0.8c0.3-5.2,0.2-10.2,0-15.8c-0.3-11.2-7.2-18.2-17.9-18.4C475.9,125.3,464.8,125.2,454,125.3
              L454,125.3z M323.9,554.7c0.4,0,0.7,0,1.1,0l0,0c0,0.3,0.1,0.8,0.1,1.4c0,0.3,0,0.7,0,1.1C324.7,556.4,324.3,555.6,323.9,554.7
              L323.9,554.7z"/>
            </svg>
      </div>
      <div class="col cont">
        <transition name="slide-fade" mode="out-in">
          <div class="cont-1" v-if="active === 'inicio'" key="inicio">
            <p>Sex, gender identity and expression, and sexual orientation. The human sexuality is conformed by different dimensions that complements each other and evolve in every one of us. Explore them here by clicking our buddy.</p>
          </div>
          <div class="cont-identity" v-if="active === 'identity'" key="identity">
            <img src="assets/images/logo-identity.svg" alt="Identidad de género" width="160">
            <p>They are the characteristics that each society assigns to what it is masculine (of the men) and feminine (of the women). Gender identity is then the subjective perception that each person has concerning their gender.</p>
            <h3>cisgender</h3>
            <p>A person who thinks, feels and acts according to the biological sex assigned at birth.</p>
            <h3>TRANSGENDER</h3>
            <p>A person who thinks, feels and acts contrary to the sex assigned at birth.</p>
            <ul>
              <li>
                Trans man: Female sex and male gender identity.
              </li>
              <li>
                Trans woman: Male sex and female gender identity.
              </li>
              <li>
                Non-binary gender / Gender queer: A person that questions that gender should be binary (male or female) and refuse to be categorized in one of these two options. They do not feel identified with any of the two genders, or they feel with both, or they flow between the two, among other alternatives. E.g., Third gender, agender, genderfluid, gender non-conforming, etc.
              </li>
            </ul>
          </div>
          <div class="cont-expression" v-if="active === 'expression'" key="expression">
            <img src="assets/images/logo-expression.svg" alt="Expresión de género" width="130">
            <p>Attributes by which people express their gender identi- ty, according to the roles, activities, and behaviors that are socially assigned to men and women. Examples are clothing, mannerisms, postures, ways of speaking and general appearance.</p>
            <h3>FEMALE</h3>
            <p>Expressions and forms culturally associated with women.</p>
            <h3>MALE</h3>
            <p>Expressions and forms culturally associated with men.</p>
            <h3>ANDROGYNOUS</h3>
            <p>It mixes feminine and masculine characteristics without being classified in a category.</p>
            <h3>BIGENDER</h3>
            <p>It varies between female and male characteris- tics at different times.</p>
          </div>
          <div class="cont-orientation" v-if="active === 'orientation'" key="orientation">
            <img src="assets/images/logo-orientation.svg" alt="Orientación Sexual" width="170">
            <p>The attraction that people feel towards others.</p>
            <h3>HETEROSEXUAL</h3>
            <p>Attracted to people of the opposite sex.</p>
            <h3>HOMOSEXUAL</h3>
            <p>They feel an attraction for people of the same sex.</p>
            <h3>BISEXUAL</h3>
            <p>Attracted to people of the opposite sex as well as of the same sex.</p>
            <h3>PANSEXUAL</h3>
            <p>They feel attracted to other people regardless of their sex/gender.</p>
            <h3>DEMISEXUAL</h3>
            <p>They feel sexual attraction only for people with whom they create a strong emotional bond.</p>
            <h3>PANROMANTIC</h3>
            <p>They establish relationships based on an emotio- nal-romantic attraction, without being limited by the sex or gender of the other person.</p>
          </div>
          <div class="cont-sex" v-if="active === 'sex'" key="sex">
            <img src="assets/images/logo-sex.svg" alt="Sexo" width="80">
            <p>Biological characteristics (genetical, hormonal, anatomical). It’s assigned at birth, looking to the external sexual organs (penis and vagina).</p>
            <h3>MALE</h3>
            <p>XY - Testosterone - Penis, testes, prostates, etc.</p>
            <h3>FEMALE</h3>
            <p>XX- Estrogen - Vagina, uterus, ovaries, etc.</p>
            <h3>INTERSEX</h3>
            <p>Ambiguous combination of these characteristics.</p>
          </div>
        </transition>
      </div>
    </div>


  </div>
</template>
<script>
export default {
  data(){
    return {
      active: 'inicio'
    }
  }
}
</script>

<style lang="scss" scoped>
h2 {
  font-family: "LaTercera", sans-serif;
  text-transform: uppercase;
  text-align: center;
}

.cols{
  display: grid;
  grid-template-columns: 4fr 3fr;
  grid-gap: 10px;
  align-items: center;

  @media (max-width: 800px){
    grid-template-columns: 1fr;
    justify-content: center;
  }
}

.cont{
  font-family: 'LaTercera', sans-serif;
  p,
  li{
    text-indent: 0;
    font-family: 'LaTercera', sans-serif;
    font-size: 13px;
    line-height: 100%;
    padding: 0;
  }
  h3{
    font-size: 18px;
    text-transform: uppercase;
  }
  img{
    max-height: 120px;
    margin-bottom: 10px;
  }
}
.cont-1{
  p{
    font-size: 21px;
  }
}

.identidad-ejes {
  max-width: $overwidth;
  margin: 1rem auto;
  display: block;
  // border: 1px solid white;
  padding: 1rem;
  overflow: hidden;
}


#trigger-identity,
#trigger-expression,
#trigger-orientation,
#trigger-sex {
  pointer-events: all;
  cursor: pointer;
  &:hover {
    animation: 1s ease shake;
    animation-fill-mode: both;
    animation-iteration-count: infinite;
  }
}

#identity,
#expression,
#orientation,
#sex{
  #text-identity,
  #text-expression,
  #text-orientation,
  #text-sex{
    cursor: pointer;
    // display: none;
    // transition: all 0.3s ease;
    // fill: white;
    // opacity: 0;
  }
  &:hover {
    #text-identity,
    #text-expression,
    #text-orientation,
    #text-sex{
      // display: block;
      // opacity: 1;
    }
  }
}

.trigger-wrapper {
  pointer-events: all;
  .svg-text {

  }

}
@keyframes shake {
  from,
  to {
    transform: translate3d(0, 0, 0);
  }

  10%,
  30%,
  50%,
  70%,
  90% {
    transform: translate3d(-2px, 0, 0);
  }

  20%,
  40%,
  60%,
  80% {
    transform: translate3d(2px, 0, 0);
  }
}
@keyframes rubberBand {
  from {
    transform: scale3d(1, 1, 1);
  }

  30% {
    transform: scale3d(1.25, 0.75, 1);
  }
  75% {
    transform: scale3d(1.05, 0.95, 1);
  }

  to {
    transform: scale3d(1, 1, 1);
  }
}
</style>

<style>
.st0 {
  fill: #4d4d4d;
}
.st1 {
  fill: #999999;
}
.st2 {
  fill: none;
  stroke: #999999;
  stroke-width: 7;
  stroke-miterlimit: 10;
}
.st3 {
  fill: none;
  stroke: #93278f;
  stroke-width: 5;
  stroke-miterlimit: 10;
}
.st4 {
  fill: #93278f;
}
.st5 {
  fill: #ffffff;
}
.st6 {
  font-family: "NeutraTextTF-Bold";
}
.st7 {
  font-size: 35px;
}
.st8 {
  letter-spacing: -2;
}
.st9 {
  fill: none;
  stroke: #ffffff;
  stroke-width: 3;
  stroke-miterlimit: 10;
}
.st10 {
  fill: none;
  stroke: #00ffff;
  stroke-width: 5;
  stroke-miterlimit: 10;
}
.st11 {
  letter-spacing: -3;
}
.st12 {
  font-family: "NeutraText-Book";
}
.st13 {
  letter-spacing: -1;
}
.st14 {
  fill: url(#trigger-expression_3);
}
.st15 {
  fill: none;
}
.st16 {
  fill: #ff00ff;
}
</style>
